<script setup lang="ts">
import NotificationItemComponent from '@toolify/client/src/modules/notifications/components/NotificationItemComponent.vue'
import {INotificationItem} from '@toolify/client/src/modules/notifications/types/INotificationItem'

interface Props {
  notificationItem: INotificationItem
}

defineProps<Props>()

interface Emits {
  (e: 'open'): void
  (e: 'close'): void
  (e: 'read', id: string, isAggregationGroup?: boolean): void
  (e: 'unread', id: string): void
  (e: 'hoverStart'): void
  (e: 'hoverEnd'): void
}

const emit = defineEmits<Emits>()
</script>

<template>
  <div
    class="floating-notification-item"
    @click="emit('open')"
    @mouseenter="emit('hoverStart')"
    @mouseleave="emit('hoverEnd')"
  >
    <NotificationItemComponent
      :primaryIconClass="notificationItem.primaryIconClass"
      :secondaryIconClass="notificationItem.secondaryIconClass"
      :titleItems="notificationItem.titleItems"
      :authorEntity="notificationItem.authorEntity"
      :viaEntity="notificationItem.viaEntity"
      :viaEntityLabel="notificationItem.viaEntityLabel"
      :createdAt="notificationItem.createdAt"
      :contentPayload="notificationItem.contentPayload"
      :contentType="notificationItem.contentType"
      :isRead="notificationItem.isRead"
      :resourceName="notificationItem.resourceName"
      :to="notificationItem.to ?? notificationItem.detailsTo"
      :isAggregationGroup="notificationItem.isAggregationGroup"
      showDismissButton
      @read="emit('read', notificationItem.id, notificationItem.isAggregationGroup)"
      @unread="emit('unread', notificationItem.id)"
      @dismiss="emit('close')"
    />
  </div>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;
  @use '@toolify/client/src/styles/light' as light;

  .floating-notification-item {
    position: relative;
    width: 360px;
    max-width: min(360px, calc(100vw - 24px));
    border-radius: map-get(variables.$radiuses, radius-2xl);
    background: map-get(variables.$colors, container-lowest);
    box-shadow: map-get(variables.$shadows, shadow-floating-card);
    overflow: hidden;
    cursor: pointer;
    @include light.floating-surface;
  }
</style>
